import {useEffect, useRef, useState} from "react";
import CountUp from "react-countup";


const AmountDepositUp = ({ accrualAmountSum }) => {
    const [value, setValue] = useState(0.00);

    useEffect(() => {
        if (typeof accrualAmountSum === "number") {
            setValue(accrualAmountSum);
        }
    }, [accrualAmountSum]);

    const previousPrice = useRef(value);
    const startValue = + previousPrice.current;
    previousPrice.current = value; // одразу оновлюємо, але стартуємо з попереднього

    return (
        <span style={{display: "flex", alignItems: "center"}}>
            <CountUp
                duration={1}
                start={startValue}
                end={accrualAmountSum}
                separator=""
                decimals={2}
                decimal="."
            />
            <p style={{fontSize: "22px", marginLeft: "5px"}}>₴</p>
        </span>
    );
};

export default AmountDepositUp;